// The fields the server needs before it will accept a new checkout address
// (`Address#contains_correct_data?`).
export const REQUIRED_NEW_ADDRESS_FIELDS = ["address1", "postal_code", "city"];

// Field errors for a new address the buyer has not filled in, keyed by the
// posted input name so `showFieldErrors` can put each one next to its input.
// Empty when the address is complete.
export function newAddressErrors(address, message) {
  return REQUIRED_NEW_ADDRESS_FIELDS.reduce((errors, field) => {
    if (!String(address?.[field] ?? "").trim()) {
      errors[`new_address[${field}]`] = message;
    }
    return errors;
  }, {});
}
